import style from './Login.module.less';
import IconFont from '@/common/IconFont';
import { Form, Input, Button } from 'antd';
import {useEffect, useState} from 'react';
import { useSelector, useDispatch, useUserInfo } from '@/hooks/hooks';
import { setUserInfo, User } from '@/store/slices/user';
import Footer from '@/common/footer/Footer';
import { instance } from '@/service';
import layer from '@/utils/layer';
import { useRouter } from '@/hooks/hooks';
import {loginVcodeSend} from '@/service/common';

export interface LoginParams{
  mobile: string;
  vcode: string;
  operatingSystem?: string;
  browserName?: string;
  browserVersion?: string;
}

const usernameKey = 'XQFX_USERNAME';
const Login: React.FC = () => {
  const { wrapper, container, logo, content, input, formWrapper, loginbtn, footer } = style;
  const [form] = Form.useForm();
  const state = useSelector(s => s.user);
  const userInfo = useUserInfo();
  const dispatch = useDispatch();
  const router = useRouter();
  const [step, setStep] = useState('ready');
  const [count, setCount] = useState(60);
  let timer: NodeJS.Timer;
  const closeCount = () => {
    setStep('ready');
    setCount(() => 60);
  };

  const startCount = () => {
    if (step === 'waiting') return false;
    setStep('waiting');
    timer = setInterval(() => {
      setCount(c => {
        const newCount = c - 1;
        if (newCount === 0) {
          clearInterval(timer);
          closeCount();
        }
        return newCount;
      });
    }, 1000);
  };

  const sendSmsStart = () => {
    form.validateFields(['mobile']).then(async () => {
      const params = form.getFieldsValue();
      const {data} = await loginVcodeSend(params.mobile);
      if (data === 1) {
        startCount();
      } else {
        const msg = data === 2 ? '操作频繁，请稍后再试' : data === 3 ? '已达日发送限额' : '发送失败';
        layer.error(msg);
      }
    });
  };

  useEffect(() => {
    if (userInfo && userInfo.userType) {
      if (userInfo.userType === 'ADMIN') {
        router.to('/mana');
      } else {
        router.to('/front');
      }
    } else {
      const username = localStorage.getItem(usernameKey);
      if (username) {
        form.setFieldsValue({
          username
        });
      }
    }
  }, []);

  const login = async () => {
    form.validateFields().then(async () => {
      const params = form.getFieldsValue();
      const res = await instance.get<CustomSuccessData<User>>('index/login/byvcode', { params });
      if (res.data.code === 'SUCCESS') {
        const token = res.headers['auth-jwt'];
        const refreshToken = res.headers['auth-jwt-refresh'];
        localStorage.setItem('token', token);
        localStorage.setItem('refreshToken', refreshToken);
        dispatch(setUserInfo({
          ...res.data.data.userPrincipal,
          schools: res.data.data.teacherSchools || [],
          permissionCodes: res.data.data.permissionCodes || [],
          eduDataScope: res.data.data.eduDataScope
        }));
        router.to('/');
      } else {
        layer.error('账号或密码错误');
      }
    });
  };

  return (
    <div className={wrapper}>
      <div className={container}>
        <div className={logo}></div>
        <div className={content}>
          <img src={require('../../assets/imgs/logo-black.svg').default} alt="" />
          <Form
            name="basic"
            initialValues={{ remember: true }}
            // onFinish={onFinish}
            // onFinishFailed={onFinishFailed}
            autoComplete="off"
            className={formWrapper}
            form={form}
          >
            <Form.Item
              name="mobile"
              validateTrigger="onBlur"
              rules={[
                { required: true, message: '请输入手机号码'},
                { pattern: /\d{11}/, message: '请输入正确的手机号码' }
              ]}
            >
              <Input
                placeholder="请输入您的手机号"
                className={input}
                maxLength={11}
                prefix={<IconFont type="icon-shouji" />}
              />
            </Form.Item>

            <Form.Item
              name="vcode"
              rules={[{ required: true, message: '验证码不能为空' }]}
            >
              <div className={style['vcode-row']}>
                <Input
                  className={`${input} ${style.vcode}`}
                  placeholder="请输入短信验证码"
                  prefix={<IconFont type="icon-yanzhengma" />}
                  autoComplete="true"
                  maxLength={6}
                />
                {
                  step === 'ready' ? <Button type={'primary'} ghost={true} className={`${style['vcode-btn']}`} onClick={sendSmsStart}>获取验证码</Button> :
                    <Button type={'primary'} ghost={true} className={`${style['vcode-btn']} ${style.disabled}`}>{count}s 后可重发</Button>
                }
              </div>
            </Form.Item>
          </Form>
          <Button loading={state.loading} type="primary" className={`${loginbtn}`} onClick={login}>登录</Button>
        </div>
      </div>
      <Footer className={footer}></Footer>
    </div>
  );
};

export default Login;
